import React from 'react';
import { useTranslation } from 'react-i18next';
import he from 'he';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, DialogContentText, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DiagnosisOverlay = ({ open, onClose, diagnosisName }) => {
    const { t } = useTranslation();

    const vysLink = `https://www.vidaysalud.com/?s=${encodeURIComponent(he.decode(diagnosisName))}`;
    const medlineLink_es = `https://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?v%3Aproject=medlineplus-spanish&v%3Asources=medlineplus-spanish-bundle&query=${encodeURIComponent(he.decode(diagnosisName))}`;
    const medlinelink_en = `https://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?v%3Aproject=medlineplus&v%3Asources=medlineplus-bundle&query=${encodeURIComponent(he.decode(diagnosisName))}`;
    const thcLink = `https://allhealthtv.com/search-filter?_sf_s=${encodeURIComponent(he.decode(diagnosisName))}`;
    
    // Read the button order (and thus enabled buttons) from the env variable.
    // Example value: "medline,vys,thc"
    const diagButtonsEnv = process.env.REACT_APP_DIAGNOSIS_BUTTONS || "medline_en,vys,thc";
    const diagButtonOrder = diagButtonsEnv.split(',').map(key => key.trim().toLowerCase());
    
    // Define configuration for each button.
    const buttonsConfig = {
        medline_es: {
            label: t("learn_more_mediline"),
            link: medlineLink_es,
            sx: { width: '100%', margin: '10px auto', padding: '10px', backgroundColor: '#B69115' },
            variant: 'contained'
        },
        medline_en: {
            label: t("learn_more_mediline"),
            link: medlinelink_en,
            sx: { width: '100%', margin: '10px auto', padding: '10px', backgroundColor: '#B69115' },
            variant: 'contained'
        },
        vys: {
            label: t("learn_more_vys"),
            link: vysLink,
            sx: { width: '100%', margin: '10px auto', padding: '10px' },
            variant: 'contained',
            color: 'primary'
        },
        thc: {
            label: t("learn_more_thc"),
            link: thcLink,
            sx: { width: '100%', margin: '10px auto', padding: '10px' },
            variant: 'contained',
            color: 'primary'
        }
    };

    // Build the buttons based on the order defined in the env variable.
    const renderButtons = diagButtonOrder.map(key => {
        const button = buttonsConfig[key];
        if (!button) return null;
        return (
            <Button
                key={key}
                variant={button.variant}
                color={button.color}
                sx={button.sx}
                onClick={() => {
                    window.open(button.link, '_blank');
                    onClose();
                }}
            >
                {button.label}
            </Button>
        );
    });
    
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <DialogActions>
                <IconButton onClick={onClose} color="primary">
                    <CloseIcon />
                </IconButton>
            </DialogActions>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '400px' }}>
                <img
                    src={'/drita_crcl.png'}
                    alt="Isabel"
                    style={{ maxHeight: '100px', width: '100px', margin: '10px auto' }}
                />
                <DialogTitle sx={{ textAlign: 'center', color: '#2F292B', fontFamily: 'Montserrat', fontSize: '24px', fontStyle: 'normal', fontWeight: '700', lineHeight: '120%', paddingBottom: '0px' }}>
                    {t("learn_more")}
                </DialogTitle>
                <DialogContentText sx={{ textAlign: 'center', color: '#2F292B', fontFamily: 'Montserrat', fontSize: '18px', fontStyle: 'normal', fontWeight: '700', lineHeight: '120%' }}>
                    {he.decode(diagnosisName)}
                </DialogContentText>
                {renderButtons}
            </DialogContent>
        </Dialog>
    );
};

export default DiagnosisOverlay;
